import { useEffect } from "react";
import {
  createBrowserRouter,
  LoaderFunctionArgs,
  redirect,
  RouterProvider,
} from "react-router-dom";

// Import Pages
import LoginPage from "./loginpage";
import RootLayout from "./rootlayout";

// Dashbaord layout
import DashboardLayout from "./landing/dashboard";

// Users Layout
import UsersTableLayout from "./landing/users";

// Subscription Layout
import SubscriptionLayout from "./landing/subscription";

// Game Download Layout
import GameDownloadLayout from "./landing/gamedownloads";

import {
  getAuthUser2,
  getOrgUsers,
  getOrgList,
  getMatchActivitySelfList,
  getMatchActivityInfo,
  getMatchActivityParticipants,
  getActivitySchedule,
  startAuthTokenRefreshTimer,
  stopAuthTokenRefreshTimer,
} from "./apiBridge";

import "antd/dist/reset.css";
import "./App.css";
import { UserInfo } from "./interface";
import SettingsPage from "./landing/settings";
import { ConfigProvider } from "antd";
import "@fontsource/poppins";
import Activities from "./landing/activity";
import CreateActivity from "./landing/activity/create";
import EditActivity from "./landing/activity/edit";
import EditActivityLayout from "./landing/activity/editLayout";
import ActivityCategories from "./landing/activity/categories";
import ActivityParticipants from "./landing/activity/participants";
import ActivitySchedule from "./landing/activity/schedule";
import ActivityBracket from "./landing/activity/bracket";
import ActivityMatches from "./landing/activity/match";
import ActivityLayout from "./landing/activity/activityLayout";
import WebLayout from "./web/webLayout";
import WebActivities from "./web/activity/list";
import WebActivityLayout from "./web/activity/infoLayout";
import { getWebActivityDetail } from "./webBridge";
import WebActivityInfo from "./web/activity/info";
import WebActivityCategoies from "./web/activity/categories";
import WebActivityParticipants from "./web/activity/participants";
import ActivityRTDS from "./web/rtds"
import ActivityCategory from "./landing/activity/category";
import ActivityDownload from "./landing/activity/download";
import BracketBuilder from "./landing/activity/bracketBuilder";

async function getUserLoader({ request }: LoaderFunctionArgs) {
  const res = await getAuthUser2();
  if (res.status === 200) {
    const data: { user_info: UserInfo } = await res.json();
    return data.user_info;
  }
  return redirect("/login");
}

async function redirectLoader({ request }: LoaderFunctionArgs) {
  console.log("check auth");
  const res = await getAuthUser2();
  if (res.status === 200) {
    const data: { user_info: UserInfo } = await res.json();
    console.log(data.user_info.role);
    return redirect(data.user_info.role === "User" ? "/" : "/organisations");
  }
  return null;
}

async function webUserLoader({ request, params }: LoaderFunctionArgs) {
  const res = await getAuthUser2();
  if (res.status === 200) {
    const data: { user_info: UserInfo } = await res.json();
    return data.user_info;
  }
  
  return null;
}

async function userTableLoader({ request, params }: LoaderFunctionArgs) {
  const orgRes = await getOrgList();
  if (orgRes.status === 200) {
    const { organizations } = await orgRes.json();
    if (organizations && organizations.length > 0) {
      const res = await getOrgUsers({ organization: organizations[0].ID });
      if (res.status === 200) {
        const temp = await res.json();
        const data: UserInfo[] = temp.organization_users;
        return data;
      } else if (res.status === 401) {
        return redirect("/login");
      }
    }
  }
  return [];
}

/*
async function subscriptionLoader({ request, params }: LoaderFunctionArgs) {
  const orgRes = await getOrgList();
  if (orgRes.status === 200) {
    const { organizations } = await orgRes.json();
    if (organizations && organizations.length > 0) {
      const res = await getSubscrtiptionData(organizations[0].ID);
      if (res.status === 200) {
        const data = await res.json();
        return data;
      } else if (res.status === 401) {
        return redirect("/login");
      }
    }
  }
  return null;
}*/

async function activityMatchSelfListLoader({ request, params }: LoaderFunctionArgs) {
  const res = await getMatchActivitySelfList("", true);
  if (res.status === 200) {
    const data = await res.json();
    return data;
  } else if (res.status === 401) {
    return redirect("/login");
  }

  let error = "Activity service is initializing. Please retry shortly.";
  try {
    const data = await res.json();
    if (data?.error) {
      error = data.error;
    }
  } catch {
    // Keep the default message when the response body is not JSON.
  }
  return { activities: [], error };
}

async function activityMatchLoader({ request, params }: LoaderFunctionArgs) {
  if (params.id) {
    const res = await getMatchActivityInfo(params.id);
    if (res.status === 200) {
      const data = await res.json();
      return data;
    } else if (res.status === 401) {
      return redirect("/login");
    }
    throw new Response("Failed to load activity data", { status: 500 });
  }
  throw new Response("Activity ID not found", { status: 404 });
}

async function activityMatchParticipantLoader({ request, params }: LoaderFunctionArgs) {
  if (params.id) {
    const res = await getMatchActivityParticipants(params.id);
    if (res.status === 200) {
      const data = await res.json();
      return data;
    } else if (res.status === 401) {
      return redirect("/login");
    }
    return null;
  }
}

async function activityMatchScheduleLoader({ request, params }: LoaderFunctionArgs) {
  if (params.id) {
    const res = await getActivitySchedule(params.id);
    if (res.status === 200) {
      const data = await res.json();
      return data;
    } else if (res.status === 401) {
      return redirect("/login");
    }
    return null;
  }
}



/*
async function activityLayoutLoader({ request, params }: LoaderFunctionArgs) {
  const orgsResponse = await getOrgList();
  if (orgsResponse.status === 200) {
    const { organizations } = await orgsResponse.json();
    
    if (!organizations || organizations.length === 0) {
      throw new Response("No organizations available for the user", { status: 400 });
    }

    const lastUsedOrgId = localStorage.getItem('lastUsedOrgId') || '';
    let targetOrgId = lastUsedOrgId;

    if (!targetOrgId || !organizations.some((org: OrganisationInfo) => org.ID === targetOrgId)) {
      targetOrgId = organizations[0].ID;
      localStorage.setItem('lastUsedOrgId', targetOrgId);
    }

    const res = await getSubscrtiptionData(targetOrgId);
    if (res.status === 200) {
      const data = await res.json();
      return {
        ...data,
        organizations,
        selectedOrgId: targetOrgId
      };
    } else if (res.status === 401) {
      return redirect("/login");
    }
    throw new Response("Failed to check subscription", { status: 500 });
  } else if (orgsResponse.status === 401) {
    return redirect("/login");
  }
  throw new Response("Failed to fetch organizations", { status: 500 });
}*/


async function webActivityLoader({ request, params }: LoaderFunctionArgs) {
  if (params.id) {
    const res = await getWebActivityDetail(params.id);
    if (res.status === 200) {
      const data = await res.json();
      return data;
    } else if (res.status === 401) {
      return redirect("/login");
    }
    throw new Response("Failed to load activity data", { status: 500 });
  }
  throw new Response("Activity ID not found", { status: 404 });
}


const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
    loader: redirectLoader,
  },
  {
    path: '/reset',
    element: <LoginPage />,
    loader: redirectLoader
  },
  {
    path: "/web/rtds",
    element: <ActivityRTDS />,
  },
  {
    path: "/web",
    element: <RootLayout />,
    loader: getUserLoader,
    children: [
      {
        index: true,
        element: <WebActivities />
      },
      {
        path: "activity/:id",
        element: <WebActivityLayout />,
        loader: webActivityLoader,
        errorElement: <div>No Activity Found</div>,
        children: [
          {
            path: "info",
            element: <WebActivityInfo />
          },
          {
            path: "categories",
            element: <WebActivityCategoies />
          },
          {
            path: "participants",
            element: <WebActivityParticipants />
          }
        ]
      }
    ]
  },
  {
    path: "/",
    element: <RootLayout />,
    loader: getUserLoader,
    children: [
      {
        index: true,
        element: <DashboardLayout />,
      },
      {
        path: "users",
        element: <UsersTableLayout />,
        loader: userTableLoader,
      },
      {
        path: "subscription",
        element: <SubscriptionLayout />,
        //loader: subscriptionLoader,
      },
      {
        path: "game",
        element: <GameDownloadLayout />,
      },
      {
        path: "activity",
        element: <ActivityLayout />,
        children: [
          {
            index: true,
            element: <Activities />,
            loader: activityMatchSelfListLoader
          },
          {
            path: "create",
            element: <CreateActivity />
          },
          {
            path: ":id",
            element: <EditActivityLayout />,
            loader: activityMatchLoader,
            children: [
              {
                path: "info",
                element:<EditActivity />,
              },
              {
                path: "download",
                element: <ActivityDownload />
              },
              {
                path: "category/:cid",
                element: <ActivityCategory />
              },
              {
                path: "bracket-builder/:cid",
                element: <BracketBuilder />
              },
              {
                path: "category",
                element: <ActivityCategories />
              },
              {
                path: "participants",
                element: <ActivityParticipants />,
                loader: activityMatchParticipantLoader
              },
              {
                path:"schedule",
                element: <ActivitySchedule />,
                loader: activityMatchScheduleLoader
              },
              {
                path: "matches",
                element: <ActivityMatches />,
              },
              {
                path: "bracket",
                element: <ActivityBracket />
              }
            ]
          }
        ]
      },
      {
        path: "settings",
        element: <SettingsPage />,
      },
    ],
  },
  {
    path: "*",
    loader: () => redirect("/"),
  },
]);

function App() {
  useEffect(() => {
    startAuthTokenRefreshTimer();
    return () => stopAuthTokenRefreshTimer();
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          // Seed Token
          colorPrimary: "#40a9ff",
          fontFamily: "Poppins",
          // Alias Token
        },
      }}
    >
      <div className="App">
        <RouterProvider router={router} />
      </div>
    </ConfigProvider>
  );
}

export default App;
